import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import * as User from '../../helpers/User';
import ChatBook from './ChatBook';
import ChatSummary from './ChatSummary';


const $= window.$;

class ChatRequest extends Component {
	constructor(props) {
		super(props);
        this.state={
           chat_request : <ChatBook/>,
           chat_summary : <ChatSummary/>,

        };
       
        this.setComp = this.setComp.bind(this);
	}

	setComp(type){
		switch (type) {
        	case 'chat_req':
				this.setState({
					chat_request : <ChatBook/>
				})
        	break;
        	case 'chat_sum':
				this.setState({
					chat_summary : <ChatSummary/>
				})
        	break;
        }
	}

	componentWillReceiveProps(nextProps) {
		$("#req").click();
	}


    componentDidMount() {

    	setTimeout(() => {
    		let self = this;
			$('#parentHorizontalTab').easyResponsiveTabs({
	            type: 'default', //Types: default, vertical, accordion
	            width: 'auto', //auto or any width like 600px
	            fit: true, // 100% fit in a container
	            //closed: 'accordion', // Start closed if in accordion view
	            tabidentify: 'hor_1', // The tab groups identifier
	            activate: function (event) { // Callback function if tab is switched

	                var $tab = $(this);
	                var $info = $('#nested-tabInfo');
	                var $name = $('span', $info);

	                $name.text($tab.text());

	                $info.show();
	            }
	        });

			$('#ChildVerticalTab_1').easyResponsiveTabs({
	            type: 'vertical',
	            width: 'auto',
	            fit: true,
	            tabidentify: 'ver_1',
	        });

	        $('.resp-accordion').click(function(){

				if($(this).next().hasClass('requestcha')){
					self.setComp('chat_req');
					
				}

				if($(this).next().hasClass('summarycha')){
					self.setComp('chat_sum');
				}
				
			});
			
        }, 2000);
		
    }




		render() {
			
			return (
				<section id="contentsection" className="contentarea" >
				    <div className="inner-title-bg journey-tit-bg">
				        <h1>
				            <span>
				                <img src={process.env.PUBLIC_URL+"/images/Ecoach-chat-icon.jpg"} align="absmiddle" alt="" border="0"/>
				            </span>E Coach Chat<br/>
				            <span className="subtitle">Schedule a one-on-one chat with your E Coach</span>
				        </h1>
				    </div>
				    <div className="myperformance ecoach-chat">
				      <section id="semana-scroll-inner" className="scroll">
				          <section className="viewport">
				            <section className="overview">
				                  <div className="inner-content">
				                      <div id="parentHorizontalTab"  >
				                          <ul className="resp-tabs-list hor_1 horizontaltabbg">
				                              <li id="req" onClick={()=>this.setComp('chat_req')}>E Coach chat request<div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" title="" border="0"/></div></li>
				                              <li id="sum" onClick={()=>this.setComp('chat_sum')}>My chat summary <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" title="" border="0"/></div></li>
				                          </ul>
				                          <div className="resp-tabs-container hor_1" >
				                              <div className="tab-content requestcha">
				                              	{this.state.chat_request}
				                              </div>
				                              <div className="tab-content summarycha">
				                              	{this.state.chat_summary}
				                              </div>
				                          </div>
				                      </div>
				                  </div>
				              </section>
				          </section>
				      </section>
				    </div>
				</section>

			);
		}
}

export default ChatRequest;



// WEBPACK FOOTER //
// ./src/personal_interactions/ecoach_request/ChatRequest.js